import './Loading.scss';

export default function Loading() {
    return (
        <div className="loading-mask">
            <div className="loading-icon">
            </div>
        </div>
    )
}